import { render } from "./imagenfinal2.vue?vue&type=template&id=a3beb8ec&scoped=true"
import script from "./imagenfinal2.vue?vue&type=script&lang=js"
export * from "./imagenfinal2.vue?vue&type=script&lang=js"

import "./imagenfinal2.vue?vue&type=style&index=0&id=a3beb8ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3beb8ec"]])

export default __exports__